import { memo, useCallback } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { MainStackProps } from '../../types/screens';
import TvPressable from '../tv_pressable';
import { commonStyles } from '../../common/styles';
import AppColors from '../../common/colors';
import useGlobalStyles from '../../common/style_context';
import TextView from '../text_view';
import localization from '../../common/localization';
import DigitalKeyboard from '../digital_keyboard';
import { useStateRef } from '../../common/hooks';
import KeyWrapper from '../key_wrapper';

type Props = MainStackProps<'ParentDialogTv'>;

const dialogStyles = [
  `w=500,bg=${AppColors.containerGray},p=24,br=16`,
  'fs=28,fw=500,c=white,tc,mb=36',
  'pb=36',
  'h=470',
];

const ParentDialogTv = memo<Props>(({ navigation }) => {
  const [pass, passRef, setPass] = useStateRef('');
  const [container, titleStyle, inputContainer, keyboardContainer] =
    useGlobalStyles(dialogStyles);

  const onType = useCallback((n: number) => setPass(p => `${p}${n}`), []);
  const onRemove = useCallback(() => setPass(p => p.slice(0, -1)), []);

  const submit = useCallback(() => {
    const route = navigation.getState().routes.at(-2)!;
    const parentCode = passRef.current;
    //@ts-ignore
    navigation.popTo(route.name, { parentCode }, { merge: true });
  }, []);
  const cancel = useCallback(() => {
    const route = navigation.getState().routes.at(-2)!;
    //@ts-ignore
    navigation.popTo(route.name, { parentCode: undefined }, { merge: true });
  }, []);

  return (
    <View style={styles.container}>
      <TvPressable onPress={cancel} style={commonStyles.fill} />
      <KeyWrapper cancel={cancel} style={container}>
        <Text style={titleStyle}>{localization.general.enterParentPass}</Text>
        <View style={inputContainer}>
          <TextView
            value={pass}
            placeholder={localization.account.password}
            secured
            focused
          />
        </View>
        <View style={keyboardContainer}>
          <DigitalKeyboard
            enabled
            submitText={localization.general.enter}
            onType={onType}
            onRemove={onRemove}
            onSubmit={submit}
          />
        </View>
      </KeyWrapper>
    </View>
  );
});
ParentDialogTv.displayName = 'ParentDialogTv';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default ParentDialogTv;
